import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import React, { Fragment, PureComponent, memo } from 'react';
import { Col, Row, List, Separator } from '@cuemath/comps';

import { openModal } from 'actions/modal';
import Link from 'comps/link';
import { InfoIcon, ProgramIcon } from 'comps/icon';
import { HighlightedRow } from 'comps/styled-row';
import { PointerText as ProgramText, CenterText as HeaderText } from 'comps/styled-text';
import MODAL from 'constants/modal';
import COLORS from 'constants/colors';

const ProgramItem = connect(null, dispatch => ({
  actions: bindActionCreators({ openModal }, dispatch),
}))(
  memo(({ actions, program, match }) => {
    const onProgramClick = () => {
      actions.openModal(
        'table',
        {
          size: 'custom',
          width: MODAL.WIDTH,
          height: MODAL.HEIGHT,
        },
        {
          tableData: program,
          title: `Program: ${program.code}`,
          tableKeys: ['id', 'code', 'name', 'grade', 'is_active', 'description'],
          keyName: {
            is_active: 'Is Active',
          },
        },
      );
    };

    const selectedProgramCode = match.params.programCode;
    return (
      <HighlightedRow
        backgroundColor={
          selectedProgramCode && selectedProgramCode === program.code
            ? COLORS.HIGHLIGHT
            : 'clear'
        }
        alignItems="center"
        gap={4}
        gutter
      >
        <Col gutter={4}>
          <Row alignItems="center">
            <Col gutter={0}>
              <ProgramIcon size={14} />
            </Col>
            <Col>
              <Link to={`/curriculum/${program.code}/`}>
                <ProgramText>{program.code}</ProgramText>
              </Link>
            </Col>
          </Row>
        </Col>
        <Col autoRight>
          <InfoIcon size={14} onClick={onProgramClick} />
        </Col>
      </HighlightedRow>
    );
  }),
);

export default class Program extends PureComponent {
  static propTypes = {
    programs: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  programIdExtractor = program => program.id;

  renderItem = ({ item: program }) => {
    const { match } = this.props;
    return (
      <Fragment>
        <ProgramItem program={program} match={match} />
        <Separator />
      </Fragment>
    );
  };

  render() {
    const { programs, match } = this.props;

    return (
      <Fragment>
        <HeaderText>Programs</HeaderText>
        <List
          match={match}
          data={programs}
          keyExtractor={this.programIdExtractor}
          renderItem={this.renderItem}
        />
      </Fragment>
    );
  }
}
